
import React from 'react';
import { Modal, Box, Typography, IconButton, TextField, MenuItem, Button, CircularProgress } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { textFieldSx } from '../../../styles/GlobalStyles';

const AssignAssistantModal = ({ 
  open, 
  handleClose, 
  assistantDetails, 
  organization, 
  setOrganization, 
  organizationList, 
  handleAssign, 
  loading 
}) => {

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="assign-assistant-modal"
      aria-describedby="modal-to-assign-assistant"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 480,
        bgcolor: 'background.paper',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        borderRadius: '16px',
        p: 4,
        outline: 'none',
      }}>
        {/* Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography id="assign-assistant-modal" variant="h6" component="h6" sx={{ fontWeight: 700, fontSize: '1.25rem' }}>
            Assign Assistant
          </Typography>
          <IconButton onClick={handleClose} size="small" sx={{ p: 0 }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* Form Fields */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="Assistant Name"
            fullWidth
            variant="outlined"
            value={assistantDetails?.Name}
            InputProps={{
              readOnly: true,
            }}
            size="small"
            sx={textFieldSx}
          />
          
            <TextField
              select
              value={organization}
              label="Selected Company"
              onChange={(e) => setOrganization(e.target.value)}
              sx={textFieldSx}
              placeholder='Select Company'
              size="small"
            >
              <MenuItem value="blank">- None -</MenuItem>
              {organizationList.map((org) => (
                <MenuItem key={org._id} value={org._id}>{org.Name}</MenuItem>
              ))}
            </TextField>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mt: 2 }}>
            {/* <Button 
              variant="outlined" 
              onClick={() => setOrganization("")}
              fullWidth
              sx={{
                fontSize: "14px",
                textTransform: "none",
                borderColor: "#02042D",
                color: "#02042D",
                borderRadius: "8px",
                padding: "10px 16px",
                '&:hover': {
                  borderColor: "#010320",
                  backgroundColor: 'rgba(2, 4, 45, 0.04)',
                },
              }}
            >
              Remove
            </Button> */}
            <Button 
              variant="contained" 
              disabled={loading} 
              onClick={handleAssign}
              fullWidth
              sx={{
                bgcolor: "#010320",
                color: "#FFF",
                textTransform: "none",
                borderRadius: "8px",
                padding: "10px 16px",
                fontSize: "14px",
                '&:hover': {
                  bgcolor: "#010320",
                },
                '&.Mui-disabled': {
                  bgcolor: "#e0e0e0",
                  color: "#9e9e9e",
                },
              }}
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: "#FFF" }} />
              ) : (
                "Save Changes"
              )}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AssignAssistantModal;
